// The order_production_types rows, named. Every id literal for this table
// belongs here so a surface that needs one imports it instead of spelling a
// bare number.
export const BAG_PRODUCTION_TYPE_ID = 1; // corte y empaque
export const ROLL_PRODUCTION_TYPE_ID = 2; // extrusión
export const PELLET_PRODUCTION_TYPE_ID = 3;
export const WASHING_PRODUCTION_TYPE_ID = 4; // lavado / compactado

export function isBagProduct({
    order_production_type_id,
}: {
    order_production_type_id: number;
}) {
    return order_production_type_id === BAG_PRODUCTION_TYPE_ID;
}

export function isRollProduct({
    order_production_type_id,
}: {
    order_production_type_id: number;
}) {
    return order_production_type_id === ROLL_PRODUCTION_TYPE_ID;
}

export function isPelletProduct({
    order_production_type_id,
}: {
    order_production_type_id: number;
}) {
    return order_production_type_id === PELLET_PRODUCTION_TYPE_ID;
}

export function isOthersProduct({
    order_production_type_id,
}: {
    order_production_type_id: number;
}) {
    return order_production_type_id === null;
}

// Single source of truth for "does an honest inventory balance exist for this
// product's production type?" — shared by every surface that shows stock so
// they can never disagree.
//
// Tracked, i.e. getProductsInventory returns a row and a 0 is a real zero:
//   - null  uncategorised legacy stock
//   - 1     corte y empaque — enters via production, leaves via delivered sales
//   - 2     extrusión — enters via production, leaves via internal consumption
//           captured in order_production_products_consumed
//
// NOT tracked — types 3 (pellet) and 4 (lavado/compactado) capture no
// consumption at all, so no honest number exists. Their absence from the
// inventory payload must read as "sin dato", never as zero stock. Keep the
// type-id knowledge here and nowhere else; see
// docs/plans/ongoing/inventory-untracked-production-types.md.
export function isInventoryTracked(
    order_production_type_id: number | null | undefined,
): boolean {
    if (
        order_production_type_id === null ||
        order_production_type_id === undefined
    ) {
        return true;
    }

    return (
        isBagProduct({ order_production_type_id }) ||
        isRollProduct({ order_production_type_id })
    );
}
